/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rating_Very_DissatisfiedInputs */

const sv_rating_very_dissatisfied = /** @type {(inputs: Rating_Very_DissatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mycket missnöjd`)
};

const en_rating_very_dissatisfied = /** @type {(inputs: Rating_Very_DissatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very dissatisfied`)
};

/**
* | output |
* | --- |
* | "Very dissatisfied" |
*
* @param {Rating_Very_DissatisfiedInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const rating_very_dissatisfied = /** @type {((inputs?: Rating_Very_DissatisfiedInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rating_Very_DissatisfiedInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_rating_very_dissatisfied(inputs)
	return en_rating_very_dissatisfied(inputs)
});